/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SMSearchFormConfiguration,
    SMSearchFormConfigurationFromJSON,
    SMSearchFormConfigurationToJSON,
    SMSearchFormData,
    SMSearchFormDataFromJSON,
    SMSearchFormDataToJSON,
    SMSearchFormValidationData,
    SMSearchFormValidationDataFromJSON,
    SMSearchFormValidationDataToJSON,
    SMSearchFormWarningsData,
    SMSearchFormWarningsDataFromJSON,
    SMSearchFormWarningsDataToJSON,
} from '../models';

export interface ApiSearchManagerSMSearchFormConfigurationGetRequest {
    supplier?: string;
}

export interface ApiSearchManagerSMSearchFormCreatePostRequest {
    sMSearchFormData?: SMSearchFormData;
}

export interface ApiSearchManagerSMSearchFormDataGetRequest {
    id?: string;
}

export interface ApiSearchManagerSMSearchFormUpdatePostRequest {
    sMSearchFormData?: SMSearchFormData;
}

export interface ApiSearchManagerSMSearchFormValidatePostRequest {
    sMSearchFormData?: SMSearchFormData;
}

export interface ApiSearchManagerSMSearchFormWarningsPostRequest {
    sMSearchFormData?: SMSearchFormData;
}

/**
 * no description
 */
export class SMSearchFormApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchManagerSMSearchFormConfigurationGetRaw(requestParameters: ApiSearchManagerSMSearchFormConfigurationGetRequest): Promise<runtime.ApiResponse<SMSearchFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.supplier !== undefined) {
            queryParameters['supplier'] = requestParameters.supplier;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMSearchFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMSearchFormConfigurationGet(requestParameters: ApiSearchManagerSMSearchFormConfigurationGetRequest): Promise<SMSearchFormConfiguration> {
        const response = await this.apiSearchManagerSMSearchFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMSearchFormCreatePostRaw(requestParameters: ApiSearchManagerSMSearchFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMSearchFormDataToJSON(requestParameters.sMSearchFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiSearchManagerSMSearchFormCreatePost(requestParameters: ApiSearchManagerSMSearchFormCreatePostRequest): Promise<string> {
        const response = await this.apiSearchManagerSMSearchFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMSearchFormDataGetRaw(requestParameters: ApiSearchManagerSMSearchFormDataGetRequest): Promise<runtime.ApiResponse<SMSearchFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMSearchFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMSearchFormDataGet(requestParameters: ApiSearchManagerSMSearchFormDataGetRequest): Promise<SMSearchFormData> {
        const response = await this.apiSearchManagerSMSearchFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMSearchFormUpdatePostRaw(requestParameters: ApiSearchManagerSMSearchFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMSearchFormDataToJSON(requestParameters.sMSearchFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerSMSearchFormUpdatePost(requestParameters: ApiSearchManagerSMSearchFormUpdatePostRequest): Promise<void> {
        await this.apiSearchManagerSMSearchFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiSearchManagerSMSearchFormValidatePostRaw(requestParameters: ApiSearchManagerSMSearchFormValidatePostRequest): Promise<runtime.ApiResponse<SMSearchFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMSearchFormDataToJSON(requestParameters.sMSearchFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMSearchFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMSearchFormValidatePost(requestParameters: ApiSearchManagerSMSearchFormValidatePostRequest): Promise<SMSearchFormValidationData> {
        const response = await this.apiSearchManagerSMSearchFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMSearchFormWarningsPostRaw(requestParameters: ApiSearchManagerSMSearchFormWarningsPostRequest): Promise<runtime.ApiResponse<SMSearchFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMSearchForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMSearchFormDataToJSON(requestParameters.sMSearchFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMSearchFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMSearchFormWarningsPost(requestParameters: ApiSearchManagerSMSearchFormWarningsPostRequest): Promise<SMSearchFormWarningsData> {
        const response = await this.apiSearchManagerSMSearchFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
